module.exports = __webpack_public_path__ + "img/金属材料学2_6.b74c921f.png";